export default __webpack_public_path__ + "error.5cd618ad.svg";